var _linearGradient, _path, _path2, _path3, _rect, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f33f5e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M36 60.057V61h26v-9c-14.372 0-26 3.551-26 8.057zM1.947 52v9h27.106v-.943C29.053 55.551 16.318 52 1.947 52z",
    className: "color57d0dd svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M32 10c-7.732 0-14 5.876-14 13.125a12.766 12.766 0 0 0 8 12.033l.4.217L28 38h8l1.6-2.625.4-.217a12.766 12.766 0 0 0 8-12.033C46 15.876 39.732 10 32 10z",
    className: "colorfcd821 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31 39.707h-2v-8.586l-4.707-4.707L25.707 25l5 5a1 1 0 0 1 .293.707zM35 39.707h-2v-9a1 1 0 0 1 .293-.707l5-5 1.414 1.414L35 31.121z",
    className: "colorec322c svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 26,
    y: 38,
    fill: "url(#gradient)",
    rx: 2,
    ry: 2,
    className: "color4d5b99 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M36 60.057V61h.225c1.653-3.992 12.548-7 25.775-7v-2c-14.372 0-26 3.551-26 8.057zM1.947 52v2c13.226 0 25.053 3.008 26.86 7h.245v-.943C29.053 55.551 16.318 52 1.947 52z",
    className: "colorb6dedc svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 26,
    y: 42,
    fill: "url(#gradient)",
    rx: 2,
    ry: 2,
    className: "color4d5b99 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M13 8.146h2v6.708h-2z",
    transform: "rotate(-63.435 14 11.5)",
    className: "colorfcd821 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M46.464 10.5h6.708v2h-6.708z",
    transform: "rotate(-18.444 49.818 11.499)",
    className: "colorfcd821 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M7 22h6v2H7zM51 22h6v2h-6z",
    className: "colorfcd821 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M10.646 35.5h6.708v2h-6.708z",
    transform: "rotate(-26.565 14 36.5)",
    className: "colorfcd821 svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M49 33.146h2v6.708h-2z",
    transform: "rotate(-63.435 50 36.5)",
    className: "colorfcd821 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M31 2h2v5h-2z",
    className: "colorfcd821 svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.947 60h60.052v2H1.947z",
    className: "color344496 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2 57h16v2H2zM46 57h16v2H46z",
    className: "color576396 svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.b16130ae25fb93d0641d74e22fcfeb4f.svg";
export { ForwardRef as ReactComponent };